import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcDocumentation = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M21 5.813c0-.725-.588-1.313-1.313-1.313",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M4.75 2A1.75 1.75 0 0 0 3 3.75v13.5c0 .966.784 1.75 1.75 1.75h11.5A1.75 1.75 0 0 0 18 17.25V3.75A1.75 1.75 0 0 0 16.25 2H4.75Zm11.5 1.75H4.75v13.5h11.5V3.75Z",
  fill: "var(--mds-nav-icon-medium)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M7.375 11.75a.875.875 0 0 0 0 1.75h6.25a.875.875 0 0 0 0-1.75h-6.25ZM6.5 9.875c0-.483.392-.875.875-.875h6.25a.875.875 0 0 1 0 1.75h-6.25a.875.875 0 0 1-.875-.875Zm0-3c0-.483.392-.875.875-.875h3.25a.875.875 0 0 1 0 1.75h-3.25a.875.875 0 0 1-.875-.875Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcDocumentation");

export { IcDocumentation };
//# sourceMappingURL=ic-documentation.js.map
